'use client';

import { FC, SVGProps } from 'react';

const IconFeatureInsightful: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path d="M15.5 14.4004C15.7 13.4004 16.2 12.7004 17 11.9004C18 11.0004 18.5 9.70039 18.5 8.40039C18.5 6.80909 17.8679 5.28297 16.7426 4.15775C15.6174 3.03253 14.0913 2.40039 12.5 2.40039C10.9087 2.40039 9.38258 3.03253 8.25736 4.15775C7.13214 5.28297 6.5 6.80909 6.5 8.40039C6.5 9.40039 6.7 10.6004 8 11.9004C8.7 12.6004 9.3 13.4004 9.5 14.4004" stroke="#7C8088" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 18.4004H15.5" stroke="#7C8088" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.5 22.4004H14.5" stroke="#7C8088" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IconFeatureInsightful;
